export enum CommunicationSubject {
  PILOT = "PILOT",
  GENERAL = "GENERAL"
}
